import { useIntl } from 'react-intl'
import {
  MobileViewHeaderContainer,
  HeaderSearchContainer
} from '../../../styled-component'

import SearchComponent from '../../../../../components/stories/molecules/search'
import { searchVariantsOptions } from '../../../../../components/stories/molecules/search/constants'
import { debounce } from 'lodash'
import { useMemo } from 'react'
import { Search } from '../../../../../components/stories/atoms/icons/core'
import colorsOptions from '../../../../../components/stories/fundamentals/colors-styles/constants'
import PropTypes from 'prop-types'

const ProjectMenuMobileSearch = ({ setSearch = () => {}, isLoading }) => {
  const { formatMessage } = useIntl()
  const debouncedSetSearch = useMemo(() => debounce(setSearch, 400), [])
  const customOnChange = (value) => {
    debouncedSetSearch(value)
  }

  return (
    <MobileViewHeaderContainer>
      <HeaderSearchContainer>
        <SearchComponent.Root
          variant={searchVariantsOptions.MOBILE}
          disabled={isLoading}
          customOnChange={customOnChange}
          placeholder={formatMessage({ id: 'search' })}
        >
          <SearchComponent.Container>
            <SearchComponent.LeadingIcon
              icon={Search}
              stroke={colorsOptions.greys['grey-50']}
            />
            <SearchComponent.Input />
            <SearchComponent.ClearButton />
          </SearchComponent.Container>
        </SearchComponent.Root>
      </HeaderSearchContainer>
    </MobileViewHeaderContainer>
  )
}

ProjectMenuMobileSearch.propTypes = {
  setSearch: PropTypes.func,
  isLoading: PropTypes.bool
}

export default ProjectMenuMobileSearch
